import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { eventDispatch } from '../../../helpers/Events';

const IntegrateButton = ({ integration }) => {
  const intl = useIntl();

  const getButtonText = () => {
    if (integration.id === 'figma') {
      return intl.formatMessage({ defaultMessage: 'Install' });
    }

    return null;
  };

  const buttonText = getButtonText();

  if (integration.website_link_text && !integration.website_url) return null;

  if (integration.id === 'figma') {
    return (
      <Button
        tag="a"
        target="_blank"
        href={integration.website_url}
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <>
      {(integration.website_url || buttonText) ? (
        <Button
          tag="a"
          target="_blank"
          href={integration.website_url}
        >
          {buttonText || integration.website_link_text}
        </Button>
      ) : (
        <>
          {integration.is_connected ? (
            <span className="onboarding-step-integrate-connected">
              {intl.formatMessage({ defaultMessage: 'Connected' })}
            </span>
          ) : (
            <Button
              tag="a"
              href={integration.authentication_url || '#connect'}
              onClick={(e) => {
                if (integration.type === 'importer') {
                  e.preventDefault();
                  eventDispatch('openImportModal', integration.id);
                }
              }}
            >
              {intl.formatMessage({ defaultMessage: 'Connect' })}
            </Button>
          )}
        </>
      )}
    </>
  );
};

IntegrateButton.propTypes = {
  integration: PropTypes.object.isRequired,
};

export default IntegrateButton;
